import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H1 } from 'foundations-components/transitional/components/H1';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LeftAlignTextDiv = styled.div.withConfig({
  displayName: "SalesServiceSeatExplainerModal__LeftAlignTextDiv",
  componentId: "xcm6gm-0"
})(({
  theme
}) => ({
  textAlign: 'left',
  marginTop: theme.space['800'],
  marginBottom: theme.space['800']
}));
const SalesServiceSeatExplainerModal = ({
  handleModalClose,
  productLine
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    width: 600,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleModalClose
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `upgrades.salesServiceSeatExplainerModal.title.${productLine}`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.salesServiceSeatExplainerModal.description'
        })
      }), /*#__PURE__*/_jsxs(LeftAlignTextDiv, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockStart: "600",
          marginBlockEnd: "50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.professional.title.${productLine}`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.professional.description.${productLine}`
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockStart: "600",
          marginBlockEnd: "50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.enterprise.title.${productLine}`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.salesServiceSeatExplainerModal.enterprise.description.${productLine}`
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleModalClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.salesServiceSeatExplainerModal.close'
        })
      })
    })]
  });
};
export default SalesServiceSeatExplainerModal;